import { useToast } from 'vue-toastification';

// 改行コードの除去
export const removeCrlf = (inputStr) => {
  if (!inputStr) return inputStr;
  return inputStr.replace(/[\r\n]/g, ''); // \r と \n を削除
};

// 共通トースト表示関数
export const showInfoToast = (message, toastId, position, timeout) => {
  const toast = useToast();

  // 同じトーストが複数表示されないように、既存のトーストを閉じる
  toast.dismiss(toastId);

  // トーストを表示
  toast.info(message, {
    id: toastId,
    position: position,
    timeout: timeout,
  });
};
